/**
 * Stacja metra → linie, na których leży. Do pokazania KOLORU LINII na liście stacji
 * (pełnoekranowy wybór w nakładce obszaru): po kolorze człowiek odnajduje stację szybciej
 * niż po nazwie, bo linię ma w głowie z planu metra, a nie z alfabetu.
 *
 * WYGENEROWANE Z BAZY, nie z pamięci — `flat.transit_stops` trzyma kolumnę `lines`:
 *
 *   select name, lines from flat.transit_stops where kind='metro' order by name;
 *
 * Skrypt generujący wczytuje nazwy z `warsawMetro.ts` i przerywa, gdy któraś lista jest
 * nadzbiorem drugiej — ten sam wniosek, co przy `warsawMetroDistricts.ts`, gdzie ręcznie
 * wpisana lista miała trzy stacje-widma i gubiła dwie prawdziwe.
 *
 * Świętokrzyska ma OBIE linie i dlatego wartością jest tablica, a nie pojedynczy symbol:
 * to jedyna przesiadka w Warszawie i jedyny wiersz, który by się nie zmieścił w modelu
 * „stacja ma linię".
 */
export type LiniaMetra = 'M1' | 'M2';

export const WARSAW_METRO_LINES: Record<string, LiniaMetra[]> = {
  'Bemowo': ['M2'],
  'Bródno': ['M2'],
  'Centrum': ['M1'],
  'Centrum Nauki Kopernik': ['M2'],
  'Dworzec Gdański': ['M1'],
  'Dworzec Wileński': ['M2'],
  'Imielin': ['M1'],
  'Kabaty': ['M1'],
  'Kondratowicza': ['M2'],
  'Księcia Janusza': ['M2'],
  'Marymont': ['M1'],
  'Młociny': ['M1'],
  'Młynów': ['M2'],
  'Natolin': ['M1'],
  'Nowy Świat-Uniwersytet': ['M2'],
  'Plac Wilsona': ['M1'],
  'Płocka': ['M2'],
  'Pole Mokotowskie': ['M1'],
  'Politechnika': ['M1'],
  'Racławicka': ['M1'],
  'Ratusz Arsenał': ['M1'],
  'Rondo Daszyńskiego': ['M2'],
  'Rondo ONZ': ['M2'],
  'Słodowiec': ['M1'],
  'Służew': ['M1'],
  'Stadion Narodowy': ['M2'],
  'Stare Bielany': ['M1'],
  'Stokłosy': ['M1'],
  'Świętokrzyska': ['M1', 'M2'],
  'Szwedzka': ['M2'],
  'Targówek Mieszkaniowy': ['M2'],
  'Trocka': ['M2'],
  'Ulrychów': ['M2'],
  'Ursynów': ['M1'],
  'Wawrzyszew': ['M1'],
  'Wierzbno': ['M1'],
  'Wilanowska': ['M1'],
  'Zacisze': ['M2'],
};
